import React, { useState } from "react";
import { Plus, Trash2, Copy } from "lucide-react";
import { useFb, inp, card, btn, btnMain, copyText, fillTemplate, Label, Empty, PageSelect } from "./shared";

const CATS = [["post", "Post caption"], ["reply", "Comment / message reply"], ["followup", "Follow-up"], ["ad", "Ad text"], ["whatsapp", "WhatsApp auto-reply"]];

const TplCard = ({ t, page, c, update, remove }) => {
  const f = (k) => ({ value: t[k] ?? "", onChange: (e) => update(t.id, { [k]: e.target.value }, false), onBlur: (e) => update(t.id, { [k]: e.target.value }) });
  const filled = fillTemplate(t.text, c, page);
  return (
    <div className={`${card} space-y-2`} data-testid={`fb-tpl-${t.id}`}>
      <div className="flex flex-wrap gap-2">
        <input {...f("name")} className={`${inp} max-w-xs flex-1 font-semibold`} data-testid={`fb-tpl-name-${t.id}`} />
        <select value={t.category} onChange={(e) => update(t.id, { category: e.target.value })} className={`${inp} max-w-[220px]`} data-testid={`fb-tpl-cat-${t.id}`}>
          {CATS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <button onClick={() => remove(t.id)} className={`${btn} ml-auto`} data-testid={`fb-tpl-delete-${t.id}`}><Trash2 size={13} /></button>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        <Label t="Template"><textarea rows={5} {...f("text")} className={inp} data-testid={`fb-tpl-text-${t.id}`} /></Label>
        <Label t="Ready to post"><div className="min-h-[124px] whitespace-pre-wrap rounded-lg bg-[#f4f8f7] p-3 text-[13.5px] text-[#0f2e2a]" data-testid={`fb-tpl-preview-${t.id}`}>{filled}</div></Label>
      </div>
      <button onClick={() => copyText(filled, "Filled template copied")} className={btnMain} data-testid={`fb-tpl-copy-${t.id}`}><Copy size={14} />Copy filled text</button>
    </div>
  );
};

export default function TemplatesSection({ pages, c }) {
  const { items, add, update, remove } = useFb("templates");
  const [pageId, setPageId] = useState("");
  const [cat, setCat] = useState("");
  const page = pages.find((p) => p.id === pageId) || pages[0];
  const list = items.filter((t) => !cat || t.category === cat);
  return (
    <div className="space-y-4" data-testid="fb-templates-section">
      <div className={`${card} flex flex-wrap items-end gap-3`}>
        <Label t="Fill for page" className="min-w-[200px]"><PageSelect pages={pages} value={pageId || page?.id || ""} onChange={setPageId} testid="fb-tpl-page" /></Label>
        <Label t="Show" className="min-w-[200px]">
          <select value={cat} onChange={(e) => setCat(e.target.value)} className={inp} data-testid="fb-tpl-filter"><option value="">All templates</option>{CATS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        </Label>
        <button onClick={() => add({ name: "New template", category: cat || "post", text: "" })} className={`${btnMain} ml-auto`} data-testid="fb-tpl-add"><Plus size={15} />New template</button>
      </div>
      <p className="text-[12.5px] text-[#6b7c79]">Placeholders: {"{phone} {whatsapp} {email} {website} {chat_link} {page} {name}"} — filled in automatically from your contact details and the chosen page.</p>
      {cat === "whatsapp" && (
        <div className="rounded-2xl border border-[#bfe9cf] bg-[#effbf3] p-4 text-[13.5px] text-[#1f4d33]" data-testid="fb-tpl-wa-help">
          <b>How to turn on auto-replies in WhatsApp Business:</b> open WhatsApp Business → <b>Settings → Business tools</b>.
          Paste the <b>Greeting message</b> under "Greeting message", the <b>Away message</b> under "Away message" (set your hours),
          and add the others under <b>Quick replies</b> with the shortcut shown (e.g. type <b>/quote</b> in a chat to send it).
        </div>
      )}
      {list.length === 0 ? <Empty testid="fb-tpl-empty">No templates here yet.</Empty> : list.map((t) => <TplCard key={t.id} t={t} page={page} c={c} update={update} remove={remove} />)}
    </div>
  );
}
